/* LIQUID_GOLD: Phase 3+ — interior page behaviour.
   Registered through window.LiquidGold. One module per interactive section. */

(function () {
  'use strict';

  var LG = window.LiquidGold;
  if (!LG) return;

  /* ===============================================================
     3.3 COMPARE TABLE — scroll hint + jump to a pricing tab
     =============================================================== */

  LG.register(
    'compare',
    function (root) {
      var tables = (root || document).querySelectorAll('[data-lg-compare]:not([data-lg-ready])');

      Array.prototype.forEach.call(tables, function (cmp) {
        cmp.setAttribute('data-lg-ready', '');

        var scroll = cmp.querySelector('[data-lg-compare-scroll]');
        var wrap = cmp.querySelector('[data-lg-compare-wrap]');

        // Drop the right-edge fade once the last column is in view.
        function update() {
          if (!scroll || !wrap) return;
          var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
          wrap.classList.toggle('lg-cmp__wrap--end', atEnd);
        }

        if (scroll) {
          scroll.addEventListener('scroll', update, { passive: true });
          window.addEventListener('resize', update, { passive: true });
          cmp._lgResize = update;
          update();
        }

        // LIQUID_GOLD: a "Join" link can point at the pricing section's anchor
        // and name a pane. If that section is on this page, switch its toggle
        // before the browser follows the hash — otherwise the link just navigates.
        cmp.addEventListener('click', function (event) {
          var link = event.target.closest('[data-lg-jump-pane]');
          if (!link || !cmp.contains(link)) return;

          var href = link.getAttribute('href') || '';
          if (href.charAt(0) !== '#') return;

          var target = document.getElementById(href.slice(1));
          if (!target) return;

          var toggle = target.querySelector('[data-lg-toggle]');
          if (toggle && typeof toggle._lgSelect === 'function') {
            toggle._lgSelect(parseInt(link.getAttribute('data-lg-jump-pane'), 10));
          }
        });
      });
    },
    function (root) {
      var tables = (root || document).querySelectorAll('[data-lg-compare]');
      Array.prototype.forEach.call(tables, function (cmp) {
        if (cmp._lgResize) window.removeEventListener('resize', cmp._lgResize);
      });
    }
  );

  /* ===============================================================
     3.1 PAGE HERO — stat count-up
     The hero is above the fold, so there is no reveal to wait for: count
     after the same 600ms the entrance animations use.
     =============================================================== */

  LG.register('heroStats', function (root) {
    var heroes = (root || document).querySelectorAll('[data-lg-hero-stats]:not([data-lg-ready])');

    Array.prototype.forEach.call(heroes, function (hero) {
      hero.setAttribute('data-lg-ready', '');
      var figures = hero.querySelectorAll('[data-lg-countup]');
      if (!figures.length) return;

      window.setTimeout(function () {
        Array.prototype.forEach.call(figures, function (fig) {
          var target = parseFloat(fig.getAttribute('data-lg-countup'));
          if (isNaN(target)) return;
          LG.countUp(fig, target, {
            duration: 1600,
            suffix: fig.getAttribute('data-lg-suffix') || ''
          });
        });
      }, LG.reducedMotion() ? 0 : 600);
    });
  });

  /* ===============================================================
     4.2 PACKAGE CARDS — prefill the inquiry form's occasion field
     A card button that links to the form's anchor on this page carries
     data-lg-prefill; the value lands in the occasion field before the jump.
     =============================================================== */

  LG.register('prefill', function (root) {
    var links = (root || document).querySelectorAll('[data-lg-prefill]:not([data-lg-ready])');

    Array.prototype.forEach.call(links, function (link) {
      link.setAttribute('data-lg-ready', '');
      link.addEventListener('click', function () {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#') return;

        var target = document.getElementById(href.slice(1));
        if (!target) return;

        var field = target.querySelector('[data-lg-field="occasion"]');
        if (field) field.value = link.getAttribute('data-lg-prefill') || '';
      });
    });
  });

  /* ===============================================================
     5.2 COUNTDOWN — one interval per instance, cleared on section unload
     Liquid renders the first frame, so this only has to keep it moving.
     =============================================================== */

  LG.register(
    'countdown',
    function (root) {
      var bands = (root || document).querySelectorAll('[data-lg-countdown]:not([data-lg-ready])');

      Array.prototype.forEach.call(bands, function (band) {
        band.setAttribute('data-lg-ready', '');

        var target = new Date(band.getAttribute('data-lg-target') || '').getTime();
        if (isNaN(target)) return; // keep the server-rendered values

        var units = {};
        ['days', 'hours', 'minutes', 'seconds'].forEach(function (u) {
          units[u] = band.querySelector('[data-lg-countdown-unit="' + u + '"]');
        });
        var caption = band.querySelector('[data-lg-countdown-caption]');
        var summary = band.querySelector('[data-lg-countdown-summary]');
        var after = band.getAttribute('data-lg-caption-after') || '';
        var summaryTpl = band.getAttribute('data-lg-summary') || '';
        var lastMinute = null;
        var timer = null;

        function pad(n) {
          return (n < 10 ? '0' : '') + n;
        }

        function tick() {
          var diff = Math.max(0, target - Date.now());
          var d = Math.floor(diff / 86400000);
          var h = Math.floor(diff / 3600000) % 24;
          var m = Math.floor(diff / 60000) % 60;
          var s = Math.floor(diff / 1000) % 60;

          if (units.days) units.days.textContent = pad(d);
          if (units.hours) units.hours.textContent = pad(h);
          if (units.minutes) units.minutes.textContent = pad(m);
          if (units.seconds) units.seconds.textContent = pad(s);

          // LIQUID_GOLD: the screen-reader sentence changes once a minute, not
          // every second — a live region that ticks would never stop talking.
          if (summary && summaryTpl && m !== lastMinute) {
            lastMinute = m;
            summary.textContent = summaryTpl
              .replace('__d__', d)
              .replace('__h__', h)
              .replace('__m__', m);
          }

          if (diff <= 0) {
            band.setAttribute('data-lg-done', '');
            if (caption && after) caption.textContent = after;
            stop();
          }
        }

        function stop() {
          if (timer) window.clearInterval(timer);
          timer = null;
        }

        tick();
        if (!band.hasAttribute('data-lg-done')) timer = window.setInterval(tick, 1000);
        band._lgStop = stop;
      });
    },
    function (root) {
      var bands = (root || document).querySelectorAll('[data-lg-countdown]');
      Array.prototype.forEach.call(bands, function (b) {
        if (b._lgStop) b._lgStop();
      });
    }
  );

  /* ===============================================================
     5.5 LINKS DRAWER — right-hand dialog with focus trap + scroll lock
     =============================================================== */

  LG.register(
    'drawer',
    function (root) {
      var openers = (root || document).querySelectorAll('[data-lg-linkdrawer-open]:not([data-lg-ready])');

      Array.prototype.forEach.call(openers, function (btn) {
        btn.setAttribute('data-lg-ready', '');

        var drawer = document.getElementById(btn.getAttribute('data-lg-linkdrawer-open'));
        if (!drawer) return;

        var panel = drawer.querySelector('[data-lg-linkdrawer-panel]');
        var release = null;
        var closing = null;

        function open() {
          if (closing) {
            window.clearTimeout(closing);
            closing = null;
          }
          drawer.hidden = false;
          // Two frames so the hidden→visible change lands before the transition.
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              drawer.classList.add('lg-linkdrawer--open');
            });
          });
          btn.setAttribute('aria-expanded', 'true');
          LG.lockScroll();
          release = LG.trapFocus(panel || drawer);
        }

        function close() {
          drawer.classList.remove('lg-linkdrawer--open');
          btn.setAttribute('aria-expanded', 'false');
          LG.unlockScroll();
          if (release) {
            release();
            release = null;
          }
          closing = window.setTimeout(
            function () {
              drawer.hidden = true;
              closing = null;
            },
            LG.reducedMotion() ? 0 : 460
          );
        }

        btn.addEventListener('click', function () {
          if (drawer.hidden) open();
          else close();
        });

        drawer.addEventListener('click', function (event) {
          if (event.target.closest('[data-lg-linkdrawer-close], [data-lg-linkdrawer-overlay]')) {
            close();
            return;
          }
          // An in-page anchor should close the drawer and let the jump happen.
          var link = event.target.closest('a[href^="#"]');
          if (link) close();
        });

        drawer.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') close();
        });

        drawer._lgClose = close;
      });
    },
    function (root) {
      var drawers = (root || document).querySelectorAll('[data-lg-linkdrawer]');
      Array.prototype.forEach.call(drawers, function (d) {
        if (d._lgClose && !d.hidden) d._lgClose();
      });
    }
  );

  /* ===============================================================
     6.3 MENU DRAWER — tabbed sheet; any [data-lg-menudrawer-open="<tab>"]
     on the page opens the first drawer found, on that tab.
     =============================================================== */

  LG.register(
    'menuDrawer',
    function (root) {
      var scope = root || document;

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-menudrawer]:not([data-lg-ready])'),
        function (drawer) {
          drawer.setAttribute('data-lg-ready', '');

          var panel = drawer.querySelector('[data-lg-menudrawer-panel]');
          var body = drawer.querySelector('[data-lg-menudrawer-body]');
          var tabs = drawer.querySelectorAll('[data-lg-menudrawer-tab]');
          var panes = drawer.querySelectorAll('[data-lg-menudrawer-pane]');
          var release = null;
          var closing = null;
          var lastOpener = null;

          function select(i) {
            var key = String(i);
            var found = false;
            Array.prototype.forEach.call(panes, function (p) {
              var on = p.getAttribute('data-lg-menudrawer-pane') === key;
              p.hidden = !on;
              if (on) found = true;
            });
            if (!found && panes[0]) {
              panes[0].hidden = false;
              key = panes[0].getAttribute('data-lg-menudrawer-pane');
            }
            Array.prototype.forEach.call(tabs, function (t) {
              t.setAttribute(
                'aria-selected',
                t.getAttribute('data-lg-menudrawer-tab') === key ? 'true' : 'false'
              );
            });
            if (body) body.scrollTop = 0;
          }

          function open(i, opener) {
            if (closing) {
              window.clearTimeout(closing);
              closing = null;
            }
            lastOpener = opener || null;
            select(i);
            drawer.hidden = false;
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                drawer.classList.add('lg-menudrawer--open');
              });
            });
            LG.lockScroll();
            release = LG.trapFocus(panel || drawer);
          }

          function close() {
            if (drawer.hidden) return;
            drawer.classList.remove('lg-menudrawer--open');
            LG.unlockScroll();
            if (release) {
              release();
              release = null;
            }
            // trapFocus restores focus to whatever was active at open; make sure
            // that is the control the visitor pressed.
            if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
            closing = window.setTimeout(
              function () {
                drawer.hidden = true;
                closing = null;
              },
              LG.reducedMotion() ? 0 : 320
            );
          }

          drawer.addEventListener('click', function (event) {
            if (event.target.closest('[data-lg-menudrawer-close]')) {
              close();
              return;
            }
            var tab = event.target.closest('[data-lg-menudrawer-tab]');
            if (tab) select(tab.getAttribute('data-lg-menudrawer-tab'));
          });
          drawer.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') close();
          });

          drawer._lgOpen = open;
          drawer._lgClose = close;
        }
      );

      // Openers can live in other sections (the hero), so the drawer is looked
      // up at click time rather than at init.
      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-menudrawer-open]:not([data-lg-ready])'),
        function (btn) {
          btn.setAttribute('data-lg-ready', '');
          btn.addEventListener('click', function (event) {
            var drawer = document.querySelector('[data-lg-menudrawer]');
            if (!drawer || typeof drawer._lgOpen !== 'function') return; // fall through to the link
            event.preventDefault();
            drawer._lgOpen(parseInt(btn.getAttribute('data-lg-menudrawer-open'), 10) || 0, btn);
          });
        }
      );
    },
    function (root) {
      Array.prototype.forEach.call(
        (root || document).querySelectorAll('[data-lg-menudrawer]'),
        function (d) {
          if (d._lgClose) d._lgClose();
        }
      );
    }
  );

  /* ===============================================================
     7.4 LIGHTBOX — the club layout image; any [data-lg-lightbox-open]
     on the page opens the first lightbox found.
     =============================================================== */

  LG.register(
    'lightbox',
    function (root) {
      var scope = root || document;

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-lightbox]:not([data-lg-ready])'),
        function (box) {
          box.setAttribute('data-lg-ready', '');

          var dialog = box.querySelector('[data-lg-lightbox-dialog]');
          var release = null;
          var closing = null;
          var lastOpener = null;

          function open(opener) {
            if (closing) {
              window.clearTimeout(closing);
              closing = null;
            }
            lastOpener = opener || null;
            box.hidden = false;
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                box.classList.add('lg-lightbox--open');
              });
            });
            LG.lockScroll();
            release = LG.trapFocus(dialog || box);
          }

          function close() {
            if (box.hidden) return;
            box.classList.remove('lg-lightbox--open');
            LG.unlockScroll();
            if (release) {
              release();
              release = null;
            }
            if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
            closing = window.setTimeout(
              function () {
                box.hidden = true;
                closing = null;
              },
              LG.reducedMotion() ? 0 : 360
            );
          }

          box.addEventListener('click', function (event) {
            if (event.target.closest('[data-lg-lightbox-close]')) close();
          });
          box.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') close();
          });

          box._lgOpen = open;
          box._lgClose = close;
        }
      );

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-lightbox-open]:not([data-lg-ready])'),
        function (btn) {
          btn.setAttribute('data-lg-ready', '');
          btn.addEventListener('click', function (event) {
            var box = document.querySelector('[data-lg-lightbox]');
            if (!box || typeof box._lgOpen !== 'function') return; // fall through to the link
            event.preventDefault();
            box._lgOpen(btn);
          });
        }
      );
    },
    function (root) {
      Array.prototype.forEach.call(
        (root || document).querySelectorAll('[data-lg-lightbox]'),
        function (b) {
          if (b._lgClose) b._lgClose();
        }
      );
    }
  );

  /* ===============================================================
     8.4 TEAM — "Read more" swaps the short bio for the full one
     =============================================================== */

  LG.register('bio', function (root) {
    var toggles = (root || document).querySelectorAll('[data-lg-bio-toggle]:not([data-lg-ready])');

    Array.prototype.forEach.call(toggles, function (btn) {
      btn.setAttribute('data-lg-ready', '');
      var full = document.getElementById(btn.getAttribute('aria-controls'));
      var card = btn.closest('.lg-team__card');
      if (!full) return;

      btn.addEventListener('click', function () {
        var open = full.hidden;
        full.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-lg-less') : btn.getAttribute('data-lg-more');
        if (card) card.classList.toggle('lg-team__card--open', open);
      });
    });
  });

  /* ===============================================================
     8.6 DIALOG — generic centred sheet; [data-lg-dialog-open="<id>"] opens
     the dialog with that id (the rate cards' service details).
     =============================================================== */

  LG.register(
    'dialog',
    function (root) {
      var scope = root || document;

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-dialog]:not([data-lg-ready])'),
        function (dlg) {
          dlg.setAttribute('data-lg-ready', '');

          var panel = dlg.querySelector('[data-lg-dialog-panel]');
          var release = null;
          var closing = null;
          var lastOpener = null;

          function open(opener) {
            if (closing) {
              window.clearTimeout(closing);
              closing = null;
            }
            lastOpener = opener || null;
            dlg.hidden = false;
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                dlg.classList.add('lg-dialog--open');
              });
            });
            LG.lockScroll();
            release = LG.trapFocus(panel || dlg);
          }

          function close() {
            if (dlg.hidden) return;
            dlg.classList.remove('lg-dialog--open');
            LG.unlockScroll();
            if (release) {
              release();
              release = null;
            }
            if (lastOpener && typeof lastOpener.focus === 'function') lastOpener.focus();
            closing = window.setTimeout(
              function () {
                dlg.hidden = true;
                closing = null;
              },
              LG.reducedMotion() ? 0 : 360
            );
          }

          dlg.addEventListener('click', function (event) {
            if (event.target.closest('[data-lg-dialog-close]')) close();
          });
          dlg.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') close();
          });

          dlg._lgOpen = open;
          dlg._lgClose = close;
        }
      );

      Array.prototype.forEach.call(
        scope.querySelectorAll('[data-lg-dialog-open]:not([data-lg-ready])'),
        function (btn) {
          btn.setAttribute('data-lg-ready', '');
          btn.addEventListener('click', function (event) {
            var dlg = document.getElementById(btn.getAttribute('data-lg-dialog-open'));
            if (!dlg || typeof dlg._lgOpen !== 'function') return;
            event.preventDefault();
            dlg._lgOpen(btn);
          });
        }
      );
    },
    function (root) {
      Array.prototype.forEach.call(
        (root || document).querySelectorAll('[data-lg-dialog]'),
        function (d) {
          if (d._lgClose) d._lgClose();
        }
      );
    }
  );

  /* ===============================================================
     4.4 INQUIRY FORM — move focus to the outcome after a round trip
     Shopify re-renders the page on submit; put focus on the success panel
     or the error summary so screen readers announce it.
     =============================================================== */

  LG.register('inquiry', function (root) {
    var outcomes = (root || document).querySelectorAll(
      '[data-lg-inquiry-success]:not([data-lg-ready]), [data-lg-inquiry-alert]:not([data-lg-ready])'
    );
    Array.prototype.forEach.call(outcomes, function (el) {
      el.setAttribute('data-lg-ready', '');
      el.focus({ preventScroll: false });
    });
  });
})();
